import { render } from "./CashRecipt.vue?vue&type=template&id=fbab75b2&scoped=true"
import script from "./CashRecipt.vue?vue&type=script&lang=js"
export * from "./CashRecipt.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=fbab75b2&scoped=true&lang=css"
import "@/assets/css/user/pages/keypad.css?vue&type=style&index=1&id=fbab75b2&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=2&id=fbab75b2&scoped=true&lang=css"
import "@/assets/css/user/dark/keypad-dark.css?vue&type=style&index=3&id=fbab75b2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbab75b2"]])

export default __exports__